// the above line makes the linter ignore Sys.* errors, Sys DOES exist, it is part of ASP.Net, but logically it does NOT exist 'here'
// requires for external dependencies and other global stuff go here
/* eslint-disable no-unused-vars */
import helper from './util/helper';
import Lazysizes from 'lazysizes';
import Swiper from '../Scripts/modules/swiper/swiper.module';
import collapse from '../Scripts/modules/collapse/collapse.module';
import navscroll from '../Scripts/modules/nav/navscroll.module';
import eventListeners from '../Scripts/modules/eventlisteners/eventlisteners.module';
import floatingLabels from '../Scripts/modules/forms/forms.module';
import gallery from '../Scripts/modules/gallery/gallery.module';
import goToPage from '../Scripts/modules/paging/paging.module';
import gridLayout from '../Scripts/modules/grid/grid.module';
import languagemenu from '../Scripts/modules/languagemenu/languagemenu.module';
import linkConverter from '../Scripts/modules/linkconverter/linkconverter.module';
import scrolling from '../Scripts/modules/scrolling/scrolling.module';
import table from '../Scripts/modules/table/table.module';
import video from '../Scripts/modules/video/video.module';
import videomodal from '../Scripts/modules/video/videomodal.module';
import popup from '../Scripts/modules/popup/popup.module';
import animation from '../Scripts/modules/animation/animation.module';
/* eslint-enable no-unused-vars */

// import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
// import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/index';
// import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/tooltip';
// import 'bootstrap/js/dist/util';

function init() {
    floatingLabels();
    gridLayout();
    collapse();
    Swiper();
    languagemenu();
    linkConverter();
    eventListeners();
    table();
    gallery();
    navscroll();
    video();
    videomodal();
    popup();
    animation();

    const toggleSidebarButton = document.querySelector('.c-sidebar__toggle--price');
    const sidebar = document.querySelector('.c-sidebar__booking');
    if (toggleSidebarButton && sidebar) {
        toggleSidebarButton.addEventListener('click', () => {
            sidebar.classList.toggle('is-open');
        });
    }
}

export default {
    init
};
